import { Breadcrumb } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const BreadcrumbItems = ({ items }) => {
  const itemList = items.map(({ title, to }) => {
    return {
      title: to ? <Link to={to}>{title}</Link> : title,
    };
  });

  return (
    <Breadcrumb className="my-4 text-[15px]" items={itemList} separator=">" />
  );
};

export default BreadcrumbItems;
